import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=1dd02cd6&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=ts&"
export * from "./orderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=1dd02cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd02cd6",
  null
  
)

export default component.exports